<template>
  <div
    v-loading="loading"
    class="identify-code-wrap"
    @click="getIdentifyCode">
    <!-- <identify-image :identifyCode="identifyCode" /> -->
    <img
      v-if="src"
      :src="src"
      class="identify-code" />
  </div>
</template>

<script>
// import IdentifyImage from '../identify-image.vue'
export default {
  name: 'IdentifyCode',
  // components: { IdentifyImage },
  data() {
    return {
      src: '', captchaKey: '', loading: false
      // identifyCode: '',
      // identifyCodes: '123456789ABCDEFGHGKMNPQRSTUVWXYZabcdefghgkmnpqrstuvwxyz' // 验证码规则
    }
  },
  mounted() {
    this.getIdentifyCode()
    // this.refreshCode()
  },
  methods: {
    // refreshCode() {
    //   this.identifyCode = ''
    //   this.makeCode(this.identifyCodes, 4)
    //   console.log(this.identifyCode)
    // },
    // makeCode(o, l) { // 生成随机验证码
    //   for (let i = 0; i < l; i++) {
    //     this.identifyCode += this.identifyCodes[
    //       Math.floor(Math.random() * (this.identifyCodes.length - 0) + 0)
    //     ]
    //   }
    // },
    getIdentifyKey() {
      return this.captchaKey
    },
    getIdentifyCode() {
      this.loading = true
      this.$$CommonApi.captcha({ })
        .then(res => {
          this.loading = false
          const { result, message, captchaKey, imageBase64 } = res.data
          if ([0].includes(result)) {
            this.src = imageBase64
            this.captchaKey = captchaKey
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
<style lang="stylus" scoped>
.identify-code-wrap, .identify-code {
  width: 100%;
  height: 100%;
}

.identify-code {
  display: block;
}
</style>
